/** @file facingStepsCycle: the next facing-steps override for the [ / ] keys (null = the clip's own). */

/** The values the keys step through, coarse to fine. */
const CYCLE: readonly (number | 'free' | null)[] = [null, 1, 2, 4, 8, 16, 32, 'free'];

/** `current` moved `dir` (+1 / -1) along `CYCLE`, clamped at both ends; an unlisted value restarts at null. */
export function facingStepsCycle(current: number | 'free' | null, dir: 1 | -1): number | 'free' | null {
  const i = CYCLE.indexOf(current);
  const next = Math.min(CYCLE.length - 1, Math.max(0, (i < 0 ? 0 : i) + dir));
  return CYCLE[next] ?? null;
}
